import { render } from "./UserSignin.vue?vue&type=template&id=85510984"
import script from "./UserSignin.vue?vue&type=script&lang=js"
export * from "./UserSignin.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/mydid-pdf-demo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__